import * as React from "react";

const CENArrowRightLong: React.FC = () => {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.2797 8.52981L11.2797 11.5298C10.9865 11.823 10.5119 11.8225 10.2191 11.5298C9.92617 11.2368 9.92617 10.7622 10.2191 10.4693L11.9406 8.75012H3.25C2.83539 8.75012 2.5 8.41496 2.5 7.97902C2.5 7.54309 2.83539 7.25012 3.25 7.25012H11.9406L10.2208 5.53027C9.92781 5.2373 9.92781 4.7627 10.2208 4.46973C10.5138 4.17676 10.9884 4.17676 11.2813 4.46973L14.2813 7.46973C14.5727 7.7634 14.5727 8.23684 14.2797 8.52981Z"
                fill="#0F96D9"
            />
        </svg>
    );
};

export default React.memo(CENArrowRightLong);
